<template>
  <keep-alive>
    <LoginPanel
      v-if="isLogin"
      @showRegister="hideLogin"
      @loginSuccess="loginSuccess"
    />
    <RegisterPanel v-else @switchLogin="showLogin" />
  </keep-alive>
</template>
<script>
import RegisterPanel from './RegisterPanel'
import LoginPanel from './LoginPanel'

export default {
  name: 'Panel',
  components: {
    LoginPanel,
    RegisterPanel
  },
  data() {
    return {
      isLogin: true
    }
  },
  methods: {
    loginSuccess() {
      this.$emit('success')
    },
    showLogin() {
      this.isLogin = true
    },
    hideLogin() {
      this.isLogin = false
    }
  }
}
</script>
<style lang="less">
@import '~uikit';
// 登录主题色覆盖
.login-main {
  form {
    .button-primary {
      background-color: var(--login-active-color);
      color: #2a323f;
      &:hover,
      &:active,
      &:focus {
        color: #2a323f;
        background-color: var(--login-active-color);
      }
      &:disabled {
        background-color: #a0aaaf;
        color: #fff;
      }
    }
    input {
      &:hover,
      &:focus,
      &:active {
        border-color: var(--login-active-color);
      }
      &::-webkit-input-placeholder {
        color: #a6adbc;
      }
      &:-moz-placeholder {
        /* Firefox 18- */
        color: #a6adbc;
      }
      &::-moz-placeholder {
        /* Firefox 19+ */
        color: #a6adbc;
      }
      &:-ms-input-placeholder {
        color: #a6adbc;
      }
    }
  }
}
</style>
